import { createAsyncThunk, createSelector, createSlice, } from '@reduxjs/toolkit';
import { generateLinkRequest, } from './service/index.js';
import { setActiveView } from '../../core/wrapperContext/wrapperContextSlice.js';
import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { addSearchParam, toAbsoluteUrl, toRelativeUrl, } from '../../../helpers/url/url.js';
export const REASON_MAP = {
    generalError: 'generalError',
    alreadyBeenUsed: 'alreadyBeenUsed',
    expiredLink: 'expiredLink',
    defaut: 'generalError',
};
export const initialPasswordlessState = {
    email: {
        value: '',
        error: false,
        errorMessage: '',
    },
    emailSent: false,
    showEmailResendSuccessAlert: false,
    isLoading: false,
    errorStatus: null,
    invalidLinkReason: null,
    stepToDisplay: null,
};
const handleStepTransition = (stepToDisplay, dispatch) => {
    if (stepToDisplay === 'invalidLinkForm') {
        dispatch(updateStepToDisplay('postInvalidLinkConfirmation'));
    }
    else if (stepToDisplay === 'postInvalidLinkConfirmation') {
        dispatch(setShowEmailResentAlert(true));
    }
    else if (stepToDisplay === 'twoStepLogin') {
        dispatch(updateStepToDisplay('twoStepPasswordlessConfirmation'));
        // TODO: replace that with navigateTo
        dispatch(setActiveView(FORM_TYPES.TWO_STEP_PASSWORDLESS_CONFIRMATION));
    }
};
export const passwordlessThunk = createAsyncThunk('passwordless/generateLinkRequest', async ({ email, returnUrl, loginSource }, { rejectWithValue, dispatch, getState }) => {
    const absoluteUrl = toAbsoluteUrl(returnUrl) || returnUrl;
    const withLoginSource = addSearchParam(absoluteUrl, 'loginSource', loginSource);
    const relativeUrlWithLoginSource = toRelativeUrl(withLoginSource) || withLoginSource;
    const generateLinkResponse = await generateLinkRequest({
        email,
        returnUrl: relativeUrlWithLoginSource,
    });
    if (generateLinkResponse.success) {
        const state = getState();
        handleStepTransition(state.features.passwordless.stepToDisplay, dispatch);
        return generateLinkResponse;
    }
    else {
        return rejectWithValue(generateLinkResponse);
    }
});
export const passwordlessSlice = createSlice({
    name: 'passwordless',
    initialState: initialPasswordlessState,
    reducers: {
        updateEmail: (state, actions) => {
            state.email.value = actions.payload;
        },
        updateEmailError: (state, actions) => {
            state.email.error = actions.payload;
        },
        updateEmailErrorMessage: (state, actions) => {
            state.email.errorMessage = actions.payload;
        },
        updateStepToDisplay: (state, actions) => {
            state.stepToDisplay = actions.payload;
        },
        clearAlerts: (state) => {
            state.showEmailResendSuccessAlert = false;
            state.errorStatus = null;
        },
        setIsLoading: (state, actions) => {
            state.isLoading = actions.payload;
        },
        setShowEmailResentAlert: (state, actions) => {
            state.showEmailResendSuccessAlert = actions.payload;
        },
        clearInput: (state) => {
            state.email.error = false;
            state.email.errorMessage = '';
            state.errorStatus = null;
        },
        setInvalidLinkReason: (state, actions) => {
            state.invalidLinkReason = actions.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(passwordlessThunk.pending, (state) => {
            state.isLoading = true;
            state.errorStatus = null;
            state.showEmailResendSuccessAlert = false;
        })
            .addCase(passwordlessThunk.fulfilled, (state) => {
            state.isLoading = false;
            state.emailSent = true;
            state.errorStatus = null;
        })
            .addCase(passwordlessThunk.rejected, (state, { payload }) => {
            state.errorStatus = payload?.status ?? 500;
            state.isLoading = false;
        });
    },
});
export const { updateEmail, setIsLoading, updateEmailErrorMessage, updateEmailError, updateStepToDisplay, clearAlerts, clearInput, setShowEmailResentAlert, setInvalidLinkReason, } = passwordlessSlice.actions;
const passwordlessState = (state) => state.features.passwordless;
export const emailSelector = createSelector(passwordlessState, ({ email }) => email);
export const showEmailResentAlertSelector = createSelector(passwordlessState, ({ showEmailResendSuccessAlert }) => showEmailResendSuccessAlert);
export const getStepToDisplaySelector = createSelector(passwordlessState, ({ stepToDisplay }) => stepToDisplay);
export const isLoadingSelector = createSelector(passwordlessState, ({ isLoading }) => isLoading);
export const errorStatusSelector = createSelector(passwordlessState, ({ errorStatus }) => errorStatus);
export const trackingPasswordlessStateSelector = createSelector(passwordlessState, ({ emailSent }) => emailSent ? 'passwordlessConfirmation' : 'passwordlessInvalid');
export const invalidLinkReasonSelector = createSelector(passwordlessState, ({ invalidLinkReason }) => invalidLinkReason);
export default passwordlessSlice.reducer;
//# sourceMappingURL=passwordlessSlice.js.map